import { RectangleSkeleton, styled } from '@zeiss/beyond-online-react';

const Container = styled.div`
  display: flex;
  gap: var(--spacing-xs);
  align-items: center;
  justify-content: flex-start;
  padding: calc(var(--spacing-2xs) + var(--spacing-px)) 0;
`;

export const TermsAndConditionsSkeleton = () => {
  return (
    <Container data-testid="terms-and-conditions-skeleton">
      <RectangleSkeleton
        height="24"
        radius="s"
        title="Rectangle Skeleton for checkbox"
        width="24"
      />
      <RectangleSkeleton
        height="24"
        radius="s"
        title="Rectangle Skeleton for label"
        width="376"
      />
    </Container>
  );
};
